import React, { useState, useEffect } from "react";
// import "./Service.css";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

import { useAuth } from "../../Context/Auth";
import { apiFetch } from "../../API/CommonApi";
import { useNavigate } from "react-router-dom";
import { notify } from "../Common";
import ServicesList from "./ServicesList";
import AddService from "./AddService";
import { btnCss } from "../../Styles";
import { loadProducts as apiLoadProducts } from "../../API/ProductLayer";
import { loadServices as apiLoadServices, downloadOrders } from "../../API/ServiceLayer";
import { checkwhatsAppBusinessAcc as WPCheck } from "../../API/AuthLayer";
import { getOrderSettings } from "../../API/OrderSettingsLayer";

// import { logOut } from "../../API/CommonApi";

function Service() {
  // const auth = useAuth();
  const navigate = useNavigate();
  const accessToken = JSON.parse(localStorage.getItem("userTokens"))?.access;
  const [services, setServices] = useState(null);
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  // const [contacts, setContacts] = useState(null);
  const [editData, setEditData] = useState(null);
  const [count, setCount] = useState(null);
  const [WpDetails, setWpDetails] = useState(null);
  const auth = useAuth();
  const [page, setPage] = useState(1);
  const [searchKey, setSearchKey] = useState(null);
  const [orderAttributes, setOrderAttributes] = useState([]);
  const [filtersQuery, setFiltersQueryState] = useState("");
  const [ordering, setOrdering] = useState("-created_at");
  const [statusList, setStatusList] = useState({});
  const [downloading, setDownloading] = useState(false);
  const [orderSettings, setOrderSettings] = useState({
    show_products_in_form: true,
    allow_delete_order: true,
    allow_order_id_edit: true,
    list_fields: [],
  });
  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };
  const handleAddorEdit = (data) => {
    setOpen(true);
    setEditData(data);
  };

  const setSearch = (value) => {
    setPage(1);
    setSearchKey(value);
  };

  const setFiltersQuery = (value) => {
    setPage(1);
    setFiltersQueryState(value);
  };

  // Load Products
  const loadProducts = (param) => {
    apiLoadProducts(param)
      .then((res) => {
        // console.log(res);
        setProducts(res);
        // console.log(products.results);
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };

  const buildFilterParams = () => {
    const params = [];
    if (searchKey) params.push(`search=${searchKey}`);
    if (filtersQuery) params.push(filtersQuery);
    if (ordering) params.push(`ordering=${ordering}`);
    return params;
  };

  const buildListParams = () => {
    return [`page=${page}`, ...buildFilterParams()].join("&");
  };

  const handleDownloadOrders = () => {
    setDownloading(true);
    const params = buildFilterParams();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone) params.push(`timezone=${encodeURIComponent(timeZone)}`);
    downloadOrders(params.join("&"))
      .then(() => {
        notify("success", "Orders downloaded");
      })
      .catch((error) => {
        console.error("Error", error);
        notify("error", "Failed to download orders");
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  // Load Services — always keep current search, filters, and sort
  const loadServices = () => {
    apiLoadServices(buildListParams())
      .then((res) => {
        setServices(res.results);
        setCount(res.count);
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };

  useEffect(() => {
    loadProducts();
    getOrderSettings()
      .then((res) => {
        if (res) {
          setOrderSettings({
            show_products_in_form: res.show_products_in_form ?? true,
            allow_delete_order: res.allow_delete_order ?? true,
            allow_order_id_edit: res.allow_order_id_edit ?? true,
            list_fields: res.list_fields || [],
          });
        }
      })
      .catch((err) => console.error("Order settings fetch error:", err));
  }, []);

  useEffect(() => {
    // Define both fetch promises
    const fetchStatuses = apiFetch('GET', 'service/order-status/?per_page=1000', null, true).then(res => res.json());
    const fetchCustomFields = apiFetch('GET', 'service/order-custom-field/?per_page=1000', null, true).then(res => res.json());

    Promise.all([fetchStatuses, fetchCustomFields])
      .then(([statusData, customFieldData]) => {
        // 1. Process Statuses into a simple array for the dropdown
        const fetchedStatusOptions = statusData.results.map(s => s.status_name);
        
        // 2. Define Standard Fields with Title Case labels
        const standardFields = [
          { 
            name: "status", 
            label: "Status", // Title Case
            type: "dropdown", 
            attrType: "dropdown", 
            options: fetchedStatusOptions // Using the freshly fetched array
          },
          { 
            name: "created_at", 
            label: "Created At", // Title Case
            type: "date", 
            attrType: "date" 
          },
          { 
            name: "completed_at", 
            label: "Completed At", // Added requirement
            type: "date", 
            attrType: "date" 
          },
        ];

        // 3. Define Dynamic Fields
        const dynamicFields = customFieldData.results.map((field) => ({
          name: field.name,
          label: field.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
          type: field.type === "dropdown" ? "dropdown" : field.type,
          attrType: field.type,
          options: field.options
        }));

        setOrderAttributes([...standardFields, ...dynamicFields]);
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  useEffect(() => {
    loadServices();
  }, [page, searchKey, filtersQuery, ordering, accessToken]);

  // useEffect(() => {
  //   loadServices();
  // }, [param]);
  // const searchFn = (event) => {
  //   setParam(`search=${event}`);
  // };

  // wpDetails
  useEffect(() => {
    WPCheck()
      .then((res) => {
        if (typeof res === "object" && res?.length !== 0) {
          auth.setWpDetails(res);
          setWpDetails(res?.[0]);
        } else {
          navigate("/whatsapp-signup");
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  return (
    <>
      <div>
        <div className="pageInNav">
          <p>Orders</p>
          <div className="inNavCtr" style={{ display: "flex", gap: "10px" }}>
            <Button
              variant="outlined"
              size="small"
              disabled={downloading}
              startIcon={<DownloadIcon />}
              onClick={handleDownloadOrders}
              sx={{
                borderRadius: "5px",
                fontWeight: 500,
                fontSize: "12px",
                height: "35px",
                textTransform: "none",
                color: "#383194",
                borderColor: "#383194",
              }}
            >
              {downloading ? "Downloading..." : "Download Orders"}
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                handleAddorEdit(null);
              }}
              sx={btnCss}
            >
              ADD Order
            </Button>
          </div>
        </div>
        <ServicesList
          handleEdit={handleAddorEdit}
          services={services}
          count={count}
          loadServices={loadServices}
          page={page}
          setPage={setPage}
          searchKey={searchKey}
          setSearch={setSearch}
          orderAttributes={orderAttributes}
          setFiltersQuery={setFiltersQuery}
          orderSettings={orderSettings}
          ordering={ordering}
          setOrdering={setOrdering}
        />
      </div>
      <AddService
        open={open}
        handleClose={handleClose}
        loadServices={loadServices}
        products={products}
        rowData={editData}
        WpDetails={WpDetails}
        flag={false}
        page={page}
        setPage={setPage}
        searchKey={searchKey}
        setSearch={setSearch}
        showProductsInForm={orderSettings.show_products_in_form}
        allowOrderIdEdit={orderSettings.allow_order_id_edit !== false}
      />
    </>
  );
}

export default Service;